export { default } from './AnimationFade'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Animation/AnimationFade/index.js